import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const AuthenticatedRoutes = ({ auth }) => {
  const path = useLocation().pathname
  const navigate = useNavigate()
  useEffect(() => {
    if (auth && !localStorage.getItem('token')) {
      if (
        path !== '/' ||
        path !== '/signin' ||
        path !== '/signin-again' ||
        path !== '/auth' ||
        path !== '/auth/google/callback'
      ) {
        navigate('/')
      }
    } else {
      if (
        localStorage.getItem('token') &&
        !auth &&
        (path === '/' ||
          path === '/signin' ||
          path === '/signin-again' ||
          path === '/auth' ||
          path === '/auth/google/callback')
      ) {
        navigate('/transcripts-summaries')
      }
    }
  }, [auth, navigate, path])
  return <></>
}

export default AuthenticatedRoutes
